
<template>
    <div>
        <page-container :top-bar="topBar" :menu="menu" :show-title-icon="true" @click.native="changeShowSpeedCall(false)"><mars-view v-if="imList.length > 0" :scroll-top="scrollTop" class="im-container"><phone-service :key-word-height="keyWordHeight" :btns="btns" :show-all-flag="showAllFlag" :state-bar="stateBar || {}" :time-obj="timeObj" :shadow-height="shadowHeight" :countdown="countdown" from="im_index" @changeFlag="changeShowAllFlag"><template slot-scope="ps"><template v-if="ps.stateBar && ps.stateBar.txt && !(ps.timeObj.h === 0 && ps.timeObj.m === 0 && ps.timeObj.s === 0)"><mars-view class="state-bar c-font-normal"><mars-text>{{ ps.stateBar.txt }} </mars-text><mars-text class="l-color-orange">{{ ps.countdown }} </mars-text><mars-text>{{ ps.stateBar.tail }}</mars-text></mars-view><mars-view :class="ps.stateBar ? 'state-shadow' : ''"></mars-view></template></template></phone-service><im-list :im-list="imList" :im-config="imConfig" :recording="recording" :show-all-flag="showAllFlag" :top-btn-consult="btns && btns.consult" :top-btn-show-time="!!stateBar.txt" :padding-bottom="imlistPaddingBootom" :disabled-msg-list="disabledMsgList" class="im" @handleDocService="handleDocService" @handleDocServiceShow="handleDocServiceShow" @imtap="tapImListFn" @clickDiscountCards="tapFn"><template slot-scope="ex"><mars-view class="hidden">
                    {{ ex.msgInfo.type === 'tip' }}
                </mars-view><mars-view class="hidden">
                    {{ ex.msgInfo.type === 'tip' }}
                </mars-view><mars-view v-if="ex.msgInfo.type === 'slogan'" class="im-slogan"><mars-text v-for="(item, index) in ex.msgInfo.content" :key="index" :class="item.type ? 'l-color-theme' : ''" @click.native="tapFn(item)">{{ item.txt }}</mars-text></mars-view><mars-view v-if="ex.msgInfo.type === 'tip'" class="im-tip"><mars-view><mars-text v-for="(item, index) in ex.msgInfo.content" :key="index" :nodes="item.txt" style="display: inline-block;" :class="[item.type ? 'l-color-theme' : '', 'content-item']" @click.native="tapFn(item)">
                            {{ item.txt }}
                        </mars-text></mars-view></mars-view><msg-container v-if="ex.msgInfo.type === 'multi'" :align="ex.msgInfo.align" :avatar="ex.msgInfo.avatar" class="im-multi"><mars-view class="im-wrap"><mars-text style="display: inline; white-space: pre-line;">{{ ex.msgInfo.content.txt }}</mars-text><mars-view v-if="ex.msgInfo.content.title"><mars-view v-for="(tit, index) in ex.msgInfo.content.title" :key="index"><mars-image class="im-multi-icon" :lazy-load="true" :src="tit.icon"></mars-image><mars-text class="im-multi-title">{{ tit.title }}</mars-text></mars-view></mars-view><mars-view v-if="ex.msgInfo.content.link" class="l-color-theme" style="display: inline;" @click.native="tapFn(ex.msgInfo.content.link)">
                            {{ ex.msgInfo.content.link.txt }}
                        </mars-view><mars-view v-if="ex.msgInfo.content.sBtns" class="c-gap-top"><mars-view v-for="(btn, index) in ex.msgInfo.content.sBtns" :key="index" class="im-multi-sb l-span" :class="{'im-disabled': btn.disabled}" :style="{
                                    color: btn.color,
                                    background: 'linear-gradient(to right,' + btn.bgColor + ')',
                                }" @click.native="tapFn(!btn.disabled ? btn : {}, null, ex.msgIdx)"><mars-view class="l-flex-fill"><mars-view class="c-font-normal"><mars-text class="l-font-strong c-gap-right-small">{{ btn.title }}</mars-text><c-icon name="arrow-right-circle" font-size="14px" class="c-font-normal"></c-icon></mars-view><mars-view class="c-font-tiny">
                                        {{ btn.sub }}
                                    </mars-view></mars-view><mars-view class="l-color-orange"><mars-view><mars-text>{{ btn.pay }}</mars-text><mars-text class="c-font-small">{{ btn.unit }}</mars-text></mars-view><mars-view v-if="btn.del" class="im-multi-del c-font-tiny">
                                        {{ btn.del }}
                                    </mars-view></mars-view></mars-view></mars-view><mars-view v-if="ex.msgInfo.content.btns" class="c-row c-gap-top"><c-button v-for="(btn, index) in ex.msgInfo.content.btns" :key="index" class="im-btn c-span6" border-radius="15px" :disabled="btn.disabled" :height="30" :type="btn.colored ? 'primary' : 'default'" :primary-color="!btn.colored ? '#333' : ''" :background="btn.colored ? '#445FBB' : ''" :margin-right="'10px'" @click.native="tapFn(!btn.disabled ? btn : {}, null, ex.msgIdx)">
                                {{ btn.txt }}
                            </c-button></mars-view></mars-view></msg-container></template></im-list><im-input v-show="!showPopup" :placeholder="placeholder" :value="textValue" :extra-status="extraStatus" :recording="recording" :extra-list="extraList" :page-from="'chat'" :service-btns="service_btns" :page-show-status="pageShowStatus" :float-btns="floatBtns" caret-color="#445FBB" :disabled="inputDisabled" :is-forbid="inputDisabled" @focus="focusFn" @blur="blurFn" @sendText="sendText" @sendImageList="sendImageList" @clickExtraItem="tapFn" @updateExtraStatus="toggleExtra" @updateRecording="toggleRecording" @updateImListPaddingBootom="updateImListPaddingBootom" @tapSendProduct="tapSendProduct" @changeShowSpeedCall="changeShowSpeedCall"></im-input></mars-view><mars-view v-else><mars-view v-if="consult"><consult-card :data="consult"></consult-card></mars-view><bottom-prompt v-if="prompt" :data="prompt" fix-bottom></bottom-prompt></mars-view><c-popup :show="showPopup" :data="curPopupData" @close="closePopupFn"></c-popup><phone-popup v-if="applyPhone" :show="!!applyPhone" :apply-phone="applyPhone" @applyPhoneClick="applyPhoneClick"></phone-popup><c-popup v-if="servicePopup" class="service-popup" :show="servicePopup" @close="closeServicePopup"><mars-view class="service-popup-content-title"><mars-text>{{ isPhoneShow ? '确认联系电话' : docServicePay.service_name }}</mars-text><mars-view class="icon iconfont law-icon-icon-close title-close" @click.native.stop="closeServicePopup"></mars-view></mars-view><mars-view class="service-popup-content" :class="{
                'service-popup-content-fixed': !isPhoneShow,
                'service-popup-conten-edit': isPhoneShow && !isPhoneEdit}"><mars-view v-if="isPhoneShow" class="service-popup-content-form"><mars-view>
                    该手机号码用于您购买服务后，律师主动致电沟通，请确认：
                </mars-view><mars-view class="input-box"><mars-input class="service-popup-content-input" :class="{'content-input-edit': isPhoneEdit}" :value="editUserPhone" :disabled="!isPhoneEdit" placeholder="请输入手机号码" @input="serviceInputChange"></mars-input><mars-view v-if="isPhoneEdit && editUserPhone" class="icon iconfont input-clear" @click.native="popupInputClear"></mars-view></mars-view><mars-view v-if="isPhoneEdit" class="content-input-button-group"><mars-button class="service-popup-content-button" :style="{'background-color': editUserPhone.length < 11 ? '#445FBBaa' : '#445FBB'}" :loading="editLoading" @click.native="handleServiceButton">确定</mars-button></mars-view><mars-view v-else class="content-input-button-group"><mars-view class="service-popup-content-button button-edit" @click.native="tapEditPhone">修改</mars-view><mars-button class="service-popup-content-button button-confirm" :loading="editLoading" @click.native="handleServiceButton">确认</mars-button></mars-view></mars-view><mars-view v-else class="service-popup-content-form"><mars-view class="service-popup-content-intro">
                    {{ productList[docServicePay.service_id].intro }}
                </mars-view><mars-view class="service-popup-content-process"><mars-image class="service-popup-content-process-img" src="https://law-smartapp.cdn.bcebos.com/service-process.png" mode="aspectFit"></mars-image></mars-view><mars-view class="service-popup-content-rules"><mars-view class="rules-title">服务规范</mars-view><mars-rich-text v-for="(item, index) in productList[docServicePay.service_id].rules" :key="index" :nodes="item" class="rules-item" :class="{'rules-item-first': index === 0}"></mars-rich-text><mars-view v-if="productList[docServicePay.service_id].call.length" class="rules-item"><mars-text v-for="item in productList[docServicePay.service_id].call" :key="item.id" :class="item.type ? 'l-color-theme' : ''" @click.native="tapFn(item)">{{ item.txt }}</mars-text></mars-view></mars-view><mars-view style="margin-top: 30px;"></mars-view></mars-view></mars-view><mars-view v-if="!isPhoneShow" class="service-popup-content-button button-fixed" @click.native="tapBuyButton">立即购买</mars-view></c-popup></page-container>
    </div>
</template>

<script>
import Container from "../../components/common/container.vue";
// import Topbar from '../../components/common/topbar';
import ImList from "../../components/IM/imList.vue";
import ImInput from "../../components/IM/imInput.vue";
import MsgContainer from "../../components/IM/msgContainer.vue";
import phonePopup from "../../components/common/phonePopup.vue";
// import ImList from '@baidu/mars-ui/components/IM/imList';
// import ImInput from '@baidu/mars-ui/components/IM/imInput';
// import MsgContainer from '@baidu/mars-ui/components/IM/msgContainer';
import TopPhoneServiceBtn from "../../components/chat/topPhoneServiceBtn.vue";
import Button from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Button/Button.vue";
import Icon from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Icon/Icon.vue";
import Popup from "../../components/common/popup.vue";
import Prompt from "../../components/common/prompt.vue";
import ConsultCard from "../../components/common/consultCard.vue";
import { getData, request } from '../../static/utils/request.js';
import { upload } from '../../static/utils/upload.js';
import { act } from '../../static/utils/navigate.js';
import { reqPathTo } from '../../static/utils/env.js';
import { purifyMsg, formatTime, time2str } from '../../static/utils/im.js';
// import {sendLog} from '../../common/js/log.js';
import { setPageInfoMenu } from '../../static/utils/setPageInfoMenu';
import { getCookie } from '../../static/utils/cookie';
import { ubcClickInit, ubcPvInit, sendUbcTimingInit, sendUbcTimingStatus, sendUbcShowLog } from '../../static/utils/ubcMethods.js';
import { ubcName } from '../imchat/ubcName';
import { mapPageUrl } from '../../static/utils/core';
import { putCpc } from '../../static/utils/cpcfree.js';
import { productList } from './product';
let productSending = false;
export default {
  components: {
    'page-container': Container,
    // 'top-bar': Topbar,
    'phone-service': TopPhoneServiceBtn,
    'im-list': ImList,
    'im-input': ImInput,
    'msg-container': MsgContainer,
    'bottom-prompt': Prompt,
    'consult-card': ConsultCard,
    'c-button': Button,
    'c-icon': Icon,
    'c-popup': Popup,
    'phone-popup': phonePopup
  },
  data() {
    return {
      dtime: '',
      pageName: 'chat',
      prePageName: '',
      timeObj: {
        h: -1,
        m: -1
      },
      // 倒计时数据对象
      countdown: '',
      // 倒计时字符串
      countdownTimer: null,
      // 倒计时定时器
      countaddTimer: null,
      // 正计时定时器
      pollingTimer: null,
      // 轮询定时器
      showAllFlag: true,
      applyPhone: null,
      postMsgUrl: '',
      // 用户消息发送接口
      refresh: '',
      // 轮询接口
      shadowHeight: 44,
      showPopup: false,
      curPopupData: {},
      placeholder: '',
      topBar: {
        title: '问一问',
        color: '#000',
        bgColor: '#ffffff'
      },
      inputDisabled: false,
      textValue: '',
      // 输入栏默认值
      extraStatus: false,
      // 抽屉栏默认状态
      recording: false,
      // 语音默认状态
      stateBar: {},
      imList: [],
      extraList: [],
      imConfig: {
        left: {
          bgColor: '#fff',
          textColor: '#333'
        },
        right: {
          bgColor: '#445FBB',
          textColor: '#fff'
        },
        system: {
          textColor: '#aaa'
        },
        timestamp: {
          bgColor: 'transparent',
          textColor: '#aaa',
          intervalTime: 300
        },
        mainBgColor: '#f4f4f4'
      },
      consult: null,
      prompt: null,
      lastMsgTime: '',
      // 列表中最后一条消息的时间戳
      menu: [],
      sessionStartTime: Date.now(),
      UInfo: {
        baiduId: '',
        uid: '',
        cuid: ''
      },
      ctx: {},
      keyWordHeight: '0',
      scrollTop: 44,
      btns: {},
      imlistPaddingBootom: 58,
      service_btns: [],
      servicePopup: false,
      productList,
      rsID: '',
      docServicePay: {
        target: '',
        type: '',
        txt: '',
        pay: ''
      },
      userPhone: null,
      editUserPhone: null,
      isPhoneShow: false,
      isPhoneEdit: false,
      editLoading: false,
      messageID: '',
      disabledMsgList: [],
      vnType: '',
      pageShowStatus: false,
      floatBtns: null
    };
  },
  created() {
    this.shadowHeight = 44;
    (function (ctx) {
      if (!this.isRunMain) {
        this.isRunMain = true;
        this.init(ctx);
      }
      this.ctx = ctx;
    }).call(this, this.$route.query);
    (function (ctx) {
      this.dtime = Date.parse(new Date()) / 1000;
      if (!this.isRunMain) {
        this.isRunMain = true;
        this.init(ctx);
      }
      try {
        const page = getCurrentPages()[getCurrentPages().length - 1]; // eslint-disable-line
        let prePage = '';
        this.pageName = mapPageUrl(page.uri) || 'lvlin';
        if (getCurrentPages().length > 1) {
          // eslint-disable-line
          prePage = getCurrentPages()[getCurrentPages().length - 2]; // eslint-disable-line
          this.prePageName = mapPageUrl(prePage.uri);
        }
      } catch (error) {}
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  }
  // 基础库 3.160.12 开始支持 需要兼容
  ,

  mounted() {
    // 获取baiduid

    this.UInfo.baiduId = getCookie('BAIDUID');
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  methods: {
    init(options) {
      getData({
        url: reqPathTo('chat', options)
      }).then(data => {
        Object.assign(this, data);
        this.vnType = data.vn_type;
        this.floatBtns = data.float_btns;
        this.topBar.title = this.topTitle;
        this._menu && (this.menu = this._menu);
        if (this.msgList) {
          // im页
          this.stateBar = this.toptip;
          this.user = this.role.user;
          this.postMsgUrl = this.tools.messageCallback;
          this.lastMsgTime = this.msgList[this.msgList.length - 1].timestamp;
          this.handleMsg({
            msgList: this.msgList,
            tools: this.tools,
            toptip: this.stateBar
          });
        } else {
          // 咨询页
          this.topBar.bgColor = '#fff';
        }
        if (data.applyPhone) {
          this.pageUbc('reqphone-show', {}, 'show');
        }
      });
    },
    /**
     * 修改右侧浮窗显示状态
     * @param {status} Boolean 点击之后浮窗显隐状态
     * @return {void}
     */
    changeShowSpeedCall(status) {
      if (status && this.pageShowStatus) {
        this.pageUbc('window-consult-click', {
          type: 'call'
        }, 'clk');
        try {
          putCpc({
            ...this.floatBtns.list[0]
          }, this, 'chat');
        } catch (error) {}
        act({
          target: this.floatBtns.list[0].target,
          type: 'call'
        });
      }
      this.pageShowStatus = status;
      if (this.pageShowStatus) {
        this.pageUbc('window-consult-click', {
          type: 'show'
        }, 'clk');
      }
    },
    /**
     * 关闭购买浮窗
     * @return {void}
     */
    closeServicePopup() {
      this.servicePopup = false;
      this.isPhoneShow = false;
      this.isPhoneEdit = false;
      this.editUserPhone = this.userPhone;
    },
    /**
     * 卡片初始化埋点上报
     * @param {item} Object 卡片数据
     * @param {align} string 头像位置
     * @return {void}
     */
    handleDocServiceShow(item, align) {
      this.pageUbc('card-show', {
        entry_type: item.service_name,
        card_ref: align === 'left' ? 'tp' : 'user',
        entry_type_id: item.service_id
      }, 'show');
    },
    /**
     * 点击商品卡片逻辑处理
     * @param {item} Object 卡片数据
     * @param {align} string 头像位置
     * @return {void}
     */
    handleDocService(item, align) {
      this.pageUbc('card-click', {
        entry_type: item.service_name,
        card_ref: align === 'left' ? 'tp' : 'user',
        entry_type_id: item.service_id
      }, 'clk');
      if (item && item.target_type === 'url') {
        const target = item.target + '&detail_ref=imchat&questionID=' + this.ctx.question_id + '&messageID=' + item.messageID;
        const type = item.target_type;
        act({
          target,
          type
        });
      } else {
        this.servicePopup = true;
        this.docServicePay = item;
        this.editUserPhone = this.userPhone;
      }
    },
    tapSendProduct(item) {
      if (!productSending) {
        productSending = true;
      } else {
        return;
      }
      this.pageUbc('quick-entry-click', {
        entry_type: item.service_name,
        entry_type_id: item.service_id
      }, 'clk');
      request({
        url: reqPathTo('consult/addservice', this.ctx, '', 'law'),
        data: {
          service_id: item.service_id,
          resource_id: this.rsID
        }
      }).then(res => {
        if (res.data.data.message && +res.data.data.message.type === 33) {
          const msg = {
            msgList: [res.data.data.message]
          };
          this.handleMsg(msg, true);
          this.messageID = res.data.data.message.messageID;
        }
        if (res.data.data.message && +res.data.data.message.type === 18) {
          const msg = {
            msgList: [res.data.data.message]
          };
          this.handleMsg(msg, true);
          this.messageID = res.data.data.message.messageID;
        }
      }).catch(() => {}).finally(() => {
        setTimeout(() => {
          productSending = false;
        }, 1000);
      });
    },
    updateImListPaddingBootom(height) {
      this.imlistPaddingBootom = height;
    },
    changeShowAllFlag(flag = true) {
      this.showAllFlag = flag;
    },
    focusFn() {
      this.keyWordHeight = '0';
      this.focusStatus = true;
      this.changeShowAllFlag(false);
    },
    blurFn() {
      this.keyWordHeight = '0';
      this.focusStatus = false;
    },
    getWebViewSystems() {
      let u = this.$api.getSystemInfoSync().system;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      // ios终端
      let isIOS = u.indexOf('iOS') > -1;
      if (isAndroid) {
        return 'Android';
      } else if (isIOS) {
        return 'iOS';
      }
    },
    clearTimer() {
      clearInterval(this.pollingTimer);
      clearInterval(this.countdownTimer);
      clearInterval(this.countaddTimer);
      this.pollingTimer = null;
      this.countdownTimer = null;
      this.countaddTimer = null;
    },
    // 启动轮询
    startPolling() {
      this.pollingTimer = setInterval(() => {
        request({
          url: this.refresh,
          data: {
            question_id: this.questionID,
            timestamp: this.lastMsgTime
          }
        }).then(res => {
          this.handleMsg(res.data.data, true);
        }).catch(() => {});
      }, 3e3);
    },
    // 开启时间自减计时器
    startTimeDecrease() {
      let obj = this.timeObj;
      if (obj.h) {
        this.countdownTimer = setInterval(() => {
          let {
            h,
            m
          } = obj;
          if (m > 0) {
            obj.m--;
            obj.s = 0;
          } else if (h > 0) {
            obj.h--;
            obj.m = 59;
            obj.s = 0;
          } else {
            this.countdownTimer = null;
            clearInterval(this.countdownTimer);
          }
        }, 6e4);
      } else {
        this.countdownTimer = setInterval(() => {
          let {
            m,
            s
          } = obj;
          if (s > 0) {
            obj.s--;
          } else if (m > 0) {
            obj.m--;
            obj.s = 59;
          } else {
            this.countdownTimer = null;
            clearInterval(this.countdownTimer);
          }
        }, 1e3);
      }
    },
    // 开启时间自增计时器
    startTimeIncreased() {
      let obj = this.timeObj;
      if (obj.h) {
        this.countaddTimer = setInterval(() => {
          let {
            h,
            m
          } = obj;
          if (m < 59) {
            obj.s = 0;
            obj.m++;
          } else if (h < 24) {
            obj.h++;
            obj.m = 0;
            obj.s = 0;
          } else {
            this.countaddTimer = null;
            clearInterval(this.countaddTimer);
          }
        }, 6e4);
      } else {
        this.countaddTimer = setInterval(() => {
          let {
            h,
            m,
            s
          } = obj;
          if (s < 59) {
            obj.s++;
          } else if (m < 59) {
            obj.s = 0;
            obj.m++;
          } else if (h < 24) {
            obj.h++;
            obj.m = 0;
            obj.s = 0;
          } else {
            this.countaddTimer = null;
            clearInterval(this.countaddTimer);
          }
        }, 1e3);
      }
    },
    // 处理接收数据
    handleMsg({
      msgList,
      tools,
      toptip
    }, isAsyncData) {
      // 消息列表处理
      if (msgList && msgList.length !== 0) {
        msgList.forEach(item => {
          // 问题关闭
          if (item.control === 'close') {
            // clearInterval(this.pollingTimer);
            clearInterval(this.countdownTimer);
            clearInterval(this.countaddTimer);
            // this.pollingTimer = null;
            this.countdownTimer = null;
            this.countaddTimer = null;
            this.countdown = '';
          }
          if (!!item.disable_msg_id && item.type === '34') {
            // eslint-disable-line
            this.imList = this.imList.map(val => {
              if (val.content.messageID === item.disable_msg_id + '') {
                val.content.disable = '1';
              }
              return val;
            });
          }
        });
        // 更新最后一条气泡的后端时间戳
        this.lastMsgTime = msgList[msgList.length - 1].timestamp;
        if (isAsyncData) {
          if (this.messageID) {
            // 忽略用户气泡
            msgList = msgList.filter(item => item.from !== 0 && +item.messageID !== +this.messageID);
            this.messageID = '';
          } else {
            // 忽略用户气泡
            msgList = msgList.filter(item => item.from !== 0);
          }
        }
        this.imList = [...this.imList, ...purifyMsg(msgList)];
      }
      // 输入框及抽屉栏处理
      if (tools) {
        let {
          usable,
          usableTxt,
          box,
          boxUsable
        } = tools;
        this.inputDisabled = !+usable;
        this.placeholder = usableTxt;
        if (+boxUsable && box && box.length !== 0) {
          this.extraList = box;
          this.extraList.forEach(item => {
            item.image = item.icon;
            item.type = item.info.type;
            item.target = item.info.callback;
          });
        } else if (!+boxUsable) {
          this.extraList = [];
        }
      }
      // 顶部状态栏处理
      if (toptip) {
        this.stateBar = toptip;
        // 开始正计时
        if (this.stateBar.counting && !this.countaddTimer) {
          this.timeObj = formatTime(this.stateBar.counting);
          this.countup = time2str(this.timeObj);
          this.startTimeIncreased();
        } else if (!this.stateBar.counting) {
          clearInterval(this.countaddTimer);
          this.countaddTimer = null;
        }
        // 开始倒计时
        if (this.stateBar.countdown && !this.countdownTimer) {
          this.timeObj = formatTime(this.stateBar.countdown);
          if (this.timeObj.h) {
            this.timeObj.s = 0;
          }
          this.countdown = time2str(this.timeObj);
          this.startTimeDecrease();
        } else if (!this.stateBar.countdown) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }
    },
    // tap交互
    tapFn({
      target,
      type,
      txt,
      pay
    }, log, msgIdx) {
      switch (type) {
        case 'uploadpic':
          upload({
            url: target,
            name: 'picFile',
            onChoose: () => this.extraStatus = false,
            onUploadSuccess: info => this.sendImg(info.resp),
            onUploadError: err => this.$api.showToast({
              title: err.toast,
              icon: 'none'
            })
          });
          break;
        case 'post':
          // 二次授权
          if (txt === '同意') {
            this.pageUbc(ubcName.SCA);
          }
          // 二次授权拒绝
          if (txt === '拒绝') {
            this.pageUbc(ubcName.SCA_REFUSE);
          }
          // 转付费咨询
          if (pay > 0) {
            this.pageUbc(ubcName.TFS);
          }
          act({
            target,
            type
          }).then(() => {
            // 置灰
            let item = this.imList[msgIdx];
            let msgContent = this.imList[msgIdx].content;
            if (msgContent.btns) {
              msgContent.btns.forEach(btn => btn.disabled = true);
            }
            if (msgContent.sBtns) {
              msgContent.sBtns.forEach(btn => btn.disabled = true);
            }
            this.imList.splice(msgIdx, 1, JSON.parse(JSON.stringify(item)));
          });
          break;
        default:
          act({
            target,
            type,
            vm: this,
            log
          });
      }
    },
    // 用户发送
    userSend(type, content, postData) {
      // 待发送气泡数据
      let toSendMsg = {
        type,
        messageID: 1 + this.imList[this.imList.length - 1].messageID,
        content,
        timestamp: new Date().getTime().toString().slice(0, -3),
        align: 'right',
        avatar: this.user.avatar,
        state: 'sending' // 发送中加载状态
      };

      let toSendIndex = this.imList.length;
      // 推送到消息列表
      this.imList.push(toSendMsg);

      // 更新im气泡状态方法
      let updateImState = (state = '', status) => {
        toSendMsg.state = state;
        this.imList.splice(toSendIndex, 1, JSON.parse(JSON.stringify(toSendMsg)));
        if (state === 'fail') {
          if (+status === 60016) {
            this.$api.showToast({
              title: '免费咨询已结束',
              icon: 'none'
            });
          } else {
            // 消息发送失败
            this.$api.showToast({
              title: '服务器异常，请稍候重试(T^T)~',
              icon: 'none'
            });
          }
        }
      };

      // 发送请求并更新气泡状态
      this.postUserMsg({
        'text': 'text',
        'img': 'image'
      }[type], postData).then(data => updateImState(data.data.messageID ? '' : 'fail', data.status)).catch(() => updateImState('fail'));
    },
    // 发送消息
    sendText(text) {
      // sendLog('chat-sendtext-clk', {text});
      this.userSend('text', text, {
        txt: text
      });
    },
    // 用户发送图片列表
    sendImageList(imageList) {
      // sendLog('chat-sendImageList-clk', imageList);
      const imListLength = this.imList.length;
      imageList.img_list && imageList.img_list.map((item, index) => {
        let toSendMsg = {
          type: 'img',
          messageID: 1 + index + this.imList[imListLength - 1].messageID,
          content: {
            thumbnail: item.img,
            origin: item.img,
            width: item.width,
            height: item.height
          },
          timestamp: new Date().getTime().toString().slice(0, -3),
          align: 'right',
          avatar: this.user.avatar,
          state: 'sending' // 发送中加载状态
        };
        // let toSendIndex = this.imList.length;
        // 推送到消息列表
        this.imList.push(toSendMsg);
        return item;
      });
      this.asyncUpdateImState(imageList);
    },
    asyncUpdateImState(imageList) {
      // 更新im气泡状态方法
      let updateImState = (state = '', status) => {
        let toSendIndex = this.imList.length - imageList.img_list.length - 1;
        let toSendMsg = this.imList[toSendIndex];
        toSendMsg.state = state;
        this.imList.splice(toSendIndex, 1, JSON.parse(JSON.stringify(toSendMsg)));
        if (state === 'fail') {
          if (+status === 60016) {
            this.$api.showToast({
              title: '免费咨询已结束',
              icon: 'none'
            });
          } else {
            // 消息发送失败
            this.$api.showToast({
              title: '服务器异常，请稍候重试(T^T)~',
              icon: 'none'
            });
          }
        }
        if (imageList.img_list && imageList.img_list.length > 0) {
          this.asyncUpdateImState({
            img_list: [...imageList.img_list]
          });
        }
      };
      this.postUserMsg('imgList', imageList.img_list.shift()).then(data => updateImState(data.data.messageID ? '' : 'fail', data.status)).catch(() => updateImState('fail'));
    },
    // 发送图片
    sendImg(info) {
      this.userSend('img', {
        thumbnail: info.small,
        origin: info.origin
      }, {
        picID: info.picID,
        orientation: info.orientation
      });
    },
    postUserMsg(type, obj) {
      return request({
        url: this.postMsgUrl,
        data: {
          question_id: this.questionID,
          type: {
            text: 0,
            // 文字
            image: 1,
            // 图片
            imgList: 27
          }[type],
          content: JSON.stringify(obj)
        }
      }).then(res => {
        this.handleMsg({
          msgList: null,
          tools: res.data.data ? res.data.data.tools : null,
          toptip: null
        });
        if (res.data && +res.data.status === 60016) {
          this.inputDisabled = false;
        }
        return res.data;
      }).catch(err => {
        return err;
      });
    },
    // im列表点击
    tapImListFn() {
      if (this.extraStatus) {
        this.toggleExtra();
      }
      if (this.recording) {
        this.toggleRecording();
      }
    },
    // 抽屉栏状态切换
    toggleExtra(bool = false) {
      this.extraStatus = bool;
    },
    // 语音状态切换
    toggleRecording(bool = false) {
      this.recording = bool;
    },
    // 关闭弹层
    closePopupFn() {
      this.showPopup = false;
    },
    pageUbc(sessionType, parmas = {}, ubcType = 'clk') {
      const extParams = {
        sid: this.ctx.sid || '',
        query: this.ctx.oriQuery || this.ctx.query || '',
        ref: getApp().globalData.ref ? getApp().globalData.ref : this.ctx.ref || '',
        // eslint-disable-line
        session_id: this.session_id || '',
        question_id: this.ctx.question_id,
        baiduid: this.UInfo.baiduId,
        cuid: this.UInfo.cuid,
        // cuid
        uid: this.UInfo.uid,
        // 用户ID
        serprovider: '',
        // 服务商
        conSource: this.ctx.ref,
        // 在线咨询来源,记录来源ID即可
        conSourceForm: this.ctx.source_from || '',
        // 在线咨询上上级来源
        eventTime: Date.now(),
        // 会话产生时间
        sessionType: sessionType,
        // 会话内容类型
        sessionId: `${this.UInfo.baiduId}-${this.sessionStartTime}`,
        // 会话ID
        content: parmas.text || '',
        // 会话内容
        sessionStartTime: this.sessionStartTime,
        // 进入会话时间
        sessionEndTime: '',
        // 结束会话时间
        scene: getApp().globalData.scene || '',
        // eslint-disable-line
        consult_type: this.vnType === 'customer_service' ? 'paper_consult' : 'online_consult',
        ...parmas
      };
      switch (ubcType) {
        case 'clk':
          ubcClickInit({
            page: this.pageName,
            from: this.prePageName,
            value: sessionType,
            ext: extParams
          });
          break;
        case 'show':
          sendUbcShowLog({
            page: this.pageName,
            from: this.prePageName,
            value: sessionType,
            ext: extParams
          });
          break;
        case 'pv':
          ubcPvInit({
            page: this.pageName,
            from: this.prePageName,
            value: sessionType,
            ext: extParams
          });
          break;
        case 'init':
          sendUbcTimingInit({
            page: this.pageName,
            from: this.prePageName,
            value: 'chat',
            ext: extParams
          });
          break;
        case 'start':
          sendUbcTimingStatus('start', {
            page: this.pageName,
            from: this.prePageName,
            value: 'chat',
            ext: extParams
          });
          break;
        case 'end':
          sendUbcTimingStatus('end', {
            page: this.pageName,
            from: this.prePageName,
            value: 'chat',
            ext: extParams
          });
          break;
        default:
          break;
      }
    },
    applyPhoneClick({
      txt,
      req1 = '',
      req2 = ''
    }) {
      this.pageUbc('reqphone-clk', {
        req1,
        req2
      }, 'clk');
    },
    tapBuyButton() {
      this.pageUbc('buy-click', {}, 'clk');
      this.isPhoneShow = true;
      if (!this.userPhone) {
        this.isPhoneEdit = true;
      }
    },
    popupInputClear() {
      this.editUserPhone = '';
    },
    tapEditPhone() {
      this.pageUbc('modify-click', {}, 'clk');
      this.isPhoneEdit = true;
      this.editUserPhone = '';
    },
    serviceInputChange(e) {
      this.editUserPhone = e.detail.value;
    },
    handleServiceButton() {
      if (this.editLoading) {
        return;
      }
      if (this.isPhoneEdit) {
        if (!this.editUserPhone) {
          this.$api.showToast({
            title: '请填写手机号',
            icon: 'none'
          });
          return;
        }
        if (this.editUserPhone.length < 11) {
          return;
        }
        if (!/^1[3-9]\d{9}$/.test(this.editUserPhone)) {
          this.$api.showToast({
            title: '手机格式错误，请重新输入',
            icon: 'none'
          });
          return;
        }
        this.pageUbc('reconfirm-click', {}, 'clk');
      } else {
        this.pageUbc('confirm-click', {}, 'clk');
      }
      this.editLoading = true;
      request({
        url: reqPathTo('consult/ordercreate', {}, '', 'law'),
        data: {
          service_id: this.docServicePay.service_id,
          resource_id: this.docServicePay.resource_id || this.rsID,
          q_id: this.questionID,
          msg_id: this.docServicePay.messageID || '',
          lawyer_phone: this.docServicePay.lawyer_phone || '',
          user_phone: this.userPhone !== this.editUserPhone ? this.editUserPhone : ''
        }
      }).then(res => {
        this.editLoading = false;
        if (+res.data.status === 0 && res.data.data.pay_url) {
          this.servicePopup = false;
          act({
            target: res.data.data.pay_url,
            type: 'pay',
            vm: this
          });
        }
        if (+res.data.status === 100006) {
          this.$api.showToast({
            title: res.data.msg || '订单已支付',
            icon: 'none'
          });
        }
      }).catch(() => {
        this.$api.showToast({
          title: '服务器繁忙，请稍后重试',
          icon: 'none'
        });
        this.editLoading = false;
      });
    },
    onPageScroll(e) {
      if (e.scrollTop >= 60 && this.showAllFlag) {
        this.changeShowAllFlag(false);
      }
      this.scrollTop = e.scrollTop;
      this.pageShowStatus = false;
    }
  },
  watch: {
    timeObj: {
      handler(newObj) {
        this.countdown = time2str(newObj);
      },
      deep: true
    }
  },
  destroyed() {
    (function () {
      this.clearTimer();
      this.pageUbc('', {}, 'end');
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$api.hideToast();
      if (!this.pollingTimer) {
        this.startPolling();
      }
      this.pageUbc('', {}, 'pv');
      this.pageUbc('', {}, 'init');
      this.pageUbc('', {}, 'start');
      setPageInfoMenu({
        title: '问一问_咨询页'
      });
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.clearTimer();
      this.pageUbc('', {}, 'end');
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.im-container .state-bar {
  position: absolute;
  z-index: 10;
  bottom: -18px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  padding: 12px 17px;
  min-width: 190px;
  color: #222;
  background: #fff;
  box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.06);
  border-radius: 19px;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0;
  font-weight: 400;
}
.im-container .im {
  position: relative;
}
.im-container .im-wrap {
  padding: 7px 12px 7px;
  text-align: left;
  color: #333;
}
.im-container .im-wrap .im-multi-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.im-container .im-wrap .im-multi-title {
  margin-left: 10px;
}
.im-container .im-disabled {
  opacity: 0.4;
}
.im-container .im-slogan {
  color: #333;
  padding: 9px 12px;
  margin-bottom: 18px;
  background-color: #fff;
  border-radius: 8px;
}
.im-container .im-tip {
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 18px;
  color: #999;
  text-align: center;
}
.im-container .im-multi {
  font-size: 14px;
  color: #999;
  text-align: center;
}
.im-container .im-multi-sb {
  height: 60px;
  padding: 0 10px;
  border-radius: 8px;
}
.im-container .im-multi-sb:not(:last-child) {
  margin-bottom: 8px;
}
.im-container .im-multi-del {
  text-decoration: line-through;
  text-align: right;
  line-height: 10px;
}
.im-container .im-btn {
  margin: 0 0 4px;
}
.state-shadow {
  height: 38px;
}
.l-color-orange {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 14px;
  color: #445fbb;
  letter-spacing: 0;
  text-align: center;
  line-height: 14px;
  font-weight: 500;
}
.hidden {
  width: 100%;
  height: 0;
  overflow: hidden;
  opacity: 0;
}
.service-popup-content-title {
  height: 67px;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/productService/bg-title.png') center center no-repeat;
  background-size: 100% 100%;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 19px;
  color: #222;
  text-align: center;
  line-height: 67px;
  font-weight: 500;
  position: relative;
}
.service-popup-content-title .title-close {
  font-size: 16px;
  color: #999;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 67px;
  width: 67px;
  height: 67px;
  text-align: center;
}
.service-popup-content {
  height: calc(70vh - 67px);
  overflow-y: auto;
}
.service-popup-content-rules {
  padding: 17px 0 0;
}
.service-popup-content-rules .rules-title {
  width: 86px;
  height: 18px;
  padding: 3px 0;
  text-align: center;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 18px;
  color: #1f1f1f;
  letter-spacing: 0;
  line-height: 18px;
  font-weight: 500;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/productService/bg-rule-title.png') center bottom no-repeat;
  background-size: 100%;
}
.service-popup-content-rules .rules-item {
  font-size: 16px;
  color: #1f1f1f;
  display: block;
  margin: 29px 0 -3px;
}
.service-popup-content-rules .rules-item-first {
  margin-top: 12px;
}
.service-popup-content-button {
  width: 100%;
  margin: 8px 0;
  height: 40px;
  background: #445fbb;
  border-radius: 24px;
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 15px;
  color: #fff;
  letter-spacing: 0;
  text-align: center;
  line-height: 44px;
  font-weight: 500;
  outline: none;
}
.service-popup-content-button::after {
  border: none;
}
.service-popup-content .input-box {
  position: relative;
  background: #f5f5f5;
  border-radius: 9px;
  padding-left: 12px;
  padding-right: 25px;
  margin: 33px 0 84px;
}
.service-popup-content-input,
.service-popup-content-input[disabled] {
  background: #f5f5f5;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #1f1f1f;
  font-weight: 400;
  outline: none;
}
.service-popup-content .content-input-edit {
  margin-top: -15px;
}
.service-popup-content .input-clear {
  width: 16px;
  height: 100%;
  color: #ccc;
  font-size: 16px;
  margin-left: 10px;
  position: absolute;
  top: 12px;
  right: 8px;
}
.service-popup-content-intro {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 18px;
  color: #1f1f1f;
  letter-spacing: 0;
  font-weight: 500;
  margin: 17px 0 -3px;
}
.service-popup-content-form {
  margin: 20px 17px 0;
}
.service-popup-content-process {
  height: 72px;
  width: 100%;
  margin-top: 20px;
  display: block;
  border-radius: 8px;
  background-image: linear-gradient(270deg, #f7f8fc 0%, #eceef8 100%);
}
.service-popup-content-process .service-popup-content-process-img {
  height: 72px;
  width: 100%;
}
.service-popup-content .content-input-button-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.service-popup-content .button-edit {
  background: #fff;
  color: #445fbb;
  width: 47%;
  border: 1px solid #445fbb;
}
.service-popup-content .button-confirm {
  width: 47%;
}
.service-popup-content-fixed {
  height: calc(70vh - 130px);
  border-bottom: 0.3px solid #e0e0e0;
}
.button-fixed {
  width: auto;
  margin: 8px 17px;
}
.service-popup-conten-edit {
  height: fit-content;
}
.service-popup /deep/ .c-container {
  padding: 0;
}
.service-popup [class*='__c-container'] {
  padding: 0;
}
.service-popup /deep/ .content {
  border-top-left-radius: 21px;
}
.service-popup [class*='__content'] {
  border-top-right-radius: 21px;
}
.im-btn {
  margin: 0 0 4px !important;
}
.im-btn:first-child {
  margin-right: 5px !important;
}

</style>
